export class ECR {
    ECRId: any = 0;
    EcrDate: any="dd/MM/yyyy";
    ECRDetails: any = '';
    TMCNo: any = "";
    AppliedOn: any;
    ECRStatus: any;
    SubmittedDate: any;
    FeelingoftheDay: any;
    ECRSubject: any;
    OtherEmail: any = [];
    Attachment: any = 0;
    ToEmail: any;
    FromEmail: string = '';
    EmployeeName: string = '';
    DefaultEmails: any;
    FavouriteEmails: any;

}
